import { createLazyFileRoute, useRouter } from "@tanstack/react-router";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { AccessionDisplay } from "@/features/accession/components/AccessionDisplay";
import {
  AccessionDisplayPopover,
  AccessionFilterPopover,
  FilterBar,
  ResetAllButton,
} from "@/features/accession/components/AccessionFilters";
import { UpdateViewForm } from "@/features/view/components/UpdateViewForm";
import { useView, ViewProvider } from "@/features/view/components/ViewProvider";
import { NavStackProvider, useInitializeNavStack } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app/views/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { view } = Route.useLoaderData();
  useInitializeNavStack();

  return (
    <NavStackProvider
      href={{ to: "/views/$id", params: { id: view.id } }}
      label={view.name}
    >
      <ViewProvider view={view}>
        <ViewHeader />
        <FilterBar />
        <AccessionDisplay
          scrollRestorationId={`accession-display-${view.id}`}
        />
        <CommandMenuProvider>
          <CommandMenu />
        </CommandMenuProvider>
      </ViewProvider>
    </NavStackProvider>
  );
}

function ViewHeader() {
  const { view, isEditing, setIsEditing } = useView();
  const router = useRouter();

  return (
    <SubHeader>
      <SubHeader.Left>
        {isEditing ? (
          <UpdateViewForm
            onUpdate={() => {
              router.invalidate();
              setIsEditing(false);
            }}
          />
        ) : (
          <Breadcrumbs>
            <Breadcrumb>{view.name}</Breadcrumb>
          </Breadcrumbs>
        )}
      </SubHeader.Left>
      <SubHeader.Right className="gap-2">
        <ResetAllButton />
        <AccessionFilterPopover />
        <AccessionDisplayPopover />
      </SubHeader.Right>
    </SubHeader>
  );
}
